// extracted by mini-css-extract-plugin
module.exports = {"R-formulariContacte":"FormulariContacte_R-formulariContacte__n7ug1"};